import React from "react"
import { NoDataGraph } from "../ImageComponents"

export const Empty = ({ label }) => {
  return (
    <div className="empty-container">
      <h1>{label}</h1>
      <lottie-player
        src={"https://assets8.lottiefiles.com/packages/lf20_dmw3t0vg.json"}
        background="transparent"
        speed="1"
        style={{ width: 300, height: 300 }}
        loop
        autoplay></lottie-player>
    </div>
  )
}

export const EmptyGraph = ({ image }) => {
  return <div className="empty-graph">{image || <NoDataGraph />}</div>
}

export const EmptyScreen = ({ image, label }) => {
  return (
    <div className="empty-screen">
      {image && <img src={image} title={label || ""} alt={`imagem ${label}`} />}
      <h4>{label}</h4>
    </div>
  )
}
